export const GREETINGS_CARD_PRODUCT_TYPE = 'greetingsCard';
export const CART_ACCESSORY_PRODUCT_TYPE = 'cartAccessory';
export const CART_ACCESSORY_PRODUCT_TYPES = [GREETINGS_CARD_PRODUCT_TYPE, CART_ACCESSORY_PRODUCT_TYPE] as const;

export type CartAccessoryProductType = (typeof CART_ACCESSORY_PRODUCT_TYPES)[number];

export type CartAccessoryItemLike = {
    itemId?: string;
    productId?: string;
    productName?: string;
    c_productType?: unknown;
    c_isCartAccessory?: boolean;
    c_nameAddressee?: unknown;
    c_messageForAddressee?: unknown;
    price?: number;
    priceAfterItemDiscount?: number;
    quantity?: number;
    c_pieceQuantity?: number;
};

export function isCartAccessoryProductType(value: unknown): value is CartAccessoryProductType {
    return CART_ACCESSORY_PRODUCT_TYPES.some((productType) => productType === value);
}

export function isCartAccessoryProductItem(item: CartAccessoryItemLike | null | undefined): boolean {
    return item?.c_isCartAccessory === true || isCartAccessoryProductType(item?.c_productType);
}

export function isGreetingsCardProductItem(item: CartAccessoryItemLike | null | undefined): boolean {
    return (
        item?.c_productType === GREETINGS_CARD_PRODUCT_TYPE ||
        (item?.c_isCartAccessory === true && Boolean(item.c_nameAddressee || item.c_messageForAddressee))
    );
}

export function getCartAccessoryProductItems<T extends CartAccessoryItemLike>(items: T[] | null | undefined): T[] {
    return (items ?? []).filter(isCartAccessoryProductItem);
}

export function getMerchandiseProductItems<T extends CartAccessoryItemLike>(items: T[] | null | undefined): T[] {
    return (items ?? []).filter((item) => !isCartAccessoryProductItem(item));
}

export function hasPhysicalMerchandise(items: CartAccessoryItemLike[] | null | undefined): boolean {
    return getMerchandiseProductItems(items).some((item) => item.c_productType === 'physical');
}

export function getMerchandiseItemCount(items: CartAccessoryItemLike[] | null | undefined): number {
    return getMerchandiseProductItems(items).reduce(
        (sum, item) => sum + (item.c_pieceQuantity ?? item.quantity ?? 0),
        0
    );
}

export function getCartAccessoryPrice(item: CartAccessoryItemLike): number {
    return item.priceAfterItemDiscount ?? item.price ?? 0;
}

export function getCartAccessoriesTotal(items: CartAccessoryItemLike[] | null | undefined): number {
    return getCartAccessoryProductItems(items).reduce((total, item) => total + getCartAccessoryPrice(item), 0);
}
